import type { StaffCoordinationScheduleResponse } from '@/types/apps/staff-coordination-schedule.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

export interface StaffCoordinationScheduleServiceInterface {}

type StaffCoordinationScheduleListResponse = ApiResponse<
    PaginatedResult<StaffCoordinationScheduleResponse>
>;

export class StaffCoordinationScheduleService implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/staff-coordination/schedule',
    };

    public index(
        params?: QueryParams
    ): Promise<StaffCoordinationScheduleListResponse> {
        return this.apiClient.postApi(this.endpoints.base(), params);
    }
}
